// src/pages/SupportPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import './SupportPage.css';

const SupportPage = () => {
  return (
    <div className="support-page">
      <div className="support-container">
        <h1>Klokify Support</h1>
        <p className="tagline">We're here to help you get the most out of Klokify</p>

        <section className="contact-section">
          <h2>Contact Support</h2>
          <div className="contact-methods">
            <div className="contact-card">
              <h3>Email Support</h3>
              <p><a href="mailto:support@klokify.de">support@klokify.de</a></p>
              <p className="response-time">Response time: 24-48 hours</p>
            </div>
            <div className="contact-card">
              <h3>General Inquiries</h3>
              <p><a href="mailto:info@klokify.de">info@klokify.de</a></p>
              <p className="response-time">For business and partnership inquiries</p>
            </div>
          </div>
        </section>

        <section className="faq-section">
          <h2>Frequently Asked Questions</h2>
          
          <div className="faq-category">
            <h3>Getting Started</h3>
            
            <div className="faq-item">
              <h4>How do I set up my company account?</h4>
              <p>After downloading the app, use your admin PIN to access company settings. From there, you can add departments, configure work hours, and invite employees to join your workspace.</p>
            </div>

            <div className="faq-item">
              <h4>How do employees clock in and out?</h4>
              <p>Employees can clock in using their 4-digit PIN on any authorized device. The app will record their time automatically, including breaks and overtime calculations.</p>
            </div>

            <div className="faq-item">
              <h4>Can I use Klokify on multiple devices?</h4>
              <p>Yes! Klokify works on iOS devices, web browsers, and can be set up in Terminal Mode for shared workplace devices.</p>
            </div>
          </div>

          <div className="faq-category">
            <h3>Features & Functionality</h3>
            
            <div className="faq-item">
              <h4>Why does the app need location access?</h4>
              <p>Location verification is optional and ensures employees clock in at the correct workplace. This feature can be enabled or disabled in company settings based on your needs.</p>
            </div>

            <div className="faq-item">
              <h4>How does offline mode work?</h4>
              <p>Klokify stores time entries locally when offline. Once internet connection is restored, all data automatically syncs with your company account.</p>
            </div>

            <div className="faq-item">
              <h4>What reports can I generate?</h4>
              <p>Generate comprehensive reports including daily/weekly/monthly summaries, overtime calculations, department analytics, and export to PDF for payroll processing.</p>
            </div>
          </div>

          <div className="faq-category">
            <h3>Account & Security</h3>
            
            <div className="faq-item">
              <h4>How do I reset my admin PIN?</h4>
              <p>For security reasons, admin PIN resets require verification. Contact <a href="mailto:support@klokify.de">support@klokify.de</a> with your company name and registration details.</p>
            </div>

            <div className="faq-item">
              <h4>Is my data secure?</h4>
              <p>Yes! We use industry-standard encryption and secure Firebase infrastructure. All data is transmitted over secure connections and stored with advanced security measures.</p>
            </div>

            <div className="faq-item">
              <h4>Can I delete my company data?</h4>
              <p>Yes, you can request complete data deletion by contacting support. We'll verify your identity and process the request within 30 days.</p>
            </div>
          </div>

          <div className="faq-category">
            <h3>Troubleshooting</h3>
            
            <div className="faq-item">
              <h4>The app isn't syncing properly</h4>
              <p>Check your internet connection and ensure you're logged in. Try logging out and back in. If issues persist, contact support with your device type and iOS version.</p>
            </div>

            <div className="faq-item">
              <h4>I can't clock in at my workplace</h4>
              <p>Verify that location services are enabled for Klokify and that you're within the designated workplace radius set by your administrator.</p>
            </div>

            <div className="faq-item">
              <h4>Reports show incorrect hours</h4>
              <p>Check that your timezone settings are correct and that all clock-ins/outs were properly recorded. Administrators can edit time entries if needed.</p>
            </div>
          </div>
        </section>

        <section className="resources-section">
          <h2>Additional Resources</h2>
          <div className="resource-links">
            <Link to="/privacy" className="resource-link">
              <h3>Privacy Policy</h3>
              <p>Learn how we protect your data</p>
            </Link>
            <a href="https://apps.apple.com/app/klokify" className="resource-link" target="_blank" rel="noopener noreferrer">
              <h3>Download on App Store</h3>
              <p>Get Klokify for iOS devices</p>
            </a>
          </div>
        </section>

        <section className="company-info">
          <h2>About Klokify</h2>
          <p>Klokify is a comprehensive time tracking solution designed for modern workplaces. Our app helps companies efficiently manage employee hours, ensure compliance, and streamline payroll processes.</p>
          <div className="company-details">
            <p><strong>Klokify</strong><br />
            Tittmoninger Str. 17<br />
            84489 Burghausen<br />
            Germany</p>
            <p>VAT ID: []<br />
            Company Registration: []</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SupportPage;